<template>
  <div class="animated fadeIn">
    <p>
      <!-- Exit -->
      After initial setup, the settings can be changed at any time.
      <b-button class="float-right" variant="link" @click="$parent.$emit('status', false)">Quick Guide Exit</b-button>
    </p>
    <b-card-group>
      <!-- .slideInDown
      .slideInLeft
      .slideInRight
      .slideInUp
      .slideOutDown
      .slideOutLeft
      .slideOutRight
      .slideOutUp -->
      <b-card v-if="step == 1" class="slideInDown slideOutDown">
        <!-- 안내 및 설정 방법 -->
        <b-row>
          <b-col class="text-center">
            <h3>
              Nice to meet you. You've installed a new agent!
            </h3>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col sm="12" class="text-center">
            <b-card-group deck style="cursor:pointer">
              <b-card bg-variant="primary" text-variant="white" header="Copy From Others policy" @click="list">
                <b-card-text>
                  <p>Apply different Web Firewall settings</p>
                  <hr>
                  <p>
                    [Select Agent] -> [Apply to other servers] -> [Apply]
                  </p>
                </b-card-text>
              </b-card>
              <b-card bg-variant="success" text-variant="white" header="Setup Policy" @click="next()">
                <b-card-text>
                  <p>Set it up quickly and operate in detection mode first.</p>
                  <hr>
                  <p>Start setting up your web firewall</p>
                </b-card-text>
              </b-card>
            </b-card-group>
          </b-col>
        </b-row>
      </b-card>
      <b-card v-if="step == 2" class="slideInLeft slideOutLeft">
        <h4>* Select the service you are using.</h4>
        <hr>
        <!-- 룰 설정 -->
        <RuleService ref="RuleService" :quick_setting="setting" :ico="ico" @toggle_policy="toggle_policy">  </RuleService>
        <hr>
        <b-form-group class="animated fadeIn fadeOut" style="cursor:pointer">
          <template #label>
            <p>
              <svg v-if="is_more" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-caret-down-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
              </svg>
              <svg v-else width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-caret-right-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.14 8.753l-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
              </svg>
              <span @click="is_more = !is_more">More : is Default recommended</span>
            </p>
            <hr>
          </template>
          <ul v-if="is_more">
            <li>
              <b-form-checkbox stacked @change="toggle_all" v-model="all_selected" :indeterminate="all_indeterminate">  {{all_selected ? 'UnCheck' : 'Check'}} All
                <b-badge variant="success">{{summary_used_count || 0}}</b-badge>
              </b-form-checkbox>
            </li>
            <hr>
            <li
              v-for="(item, index) in policy_summary_list"
              v-bind:key="index"
              >
              <b-form-checkbox style="cursor:pointer;" :id="`check_${index}`" :indeterminate="item.indeterminate" v-model="item.use" stacked @change="toggle_one($event, item.value)"> {{item.text}}  </b-form-checkbox>
            </li>
          </ul>
        </b-form-group>
      </b-card>
      <b-card v-if="step == 3" class="slideInLeft slideOutLeft">
        <!-- 허용 아이피 설정 -->
        <RuleIP :origin="{ allow_ip : policy.allow_ip, block_ip : policy.block_ip }" @block_ip="($val, key) => policy.block_ip = $val" @allow_ip="($val, key) => policy.allow_ip = $val" :is_setup="true"></RuleIP>
      </b-card>
      <b-card v-if="step == 4" class="slideInLeft slideOutLeft">
        <!-- 경로 설정 -->
        <RuleCustom
          :origin="policy.path"
          name="path"
          :is_setup="true"
          example="/admin,/manager,/images"
          @update="($val, key) => policy.path = $val"
        ></RuleCustom>
      </b-card>
      <b-card v-if="step == 5" class="slideInLeft slideOutLeft">
        <!-- 운영 모드 및 레벨 확인 -->
        <RuleMode
          :setting="policy"
          :is_first="is_first"
          @update="($val, key) => policy[key] = $val"
        >
        </RuleMode>
      </b-card>
    </b-card-group>
    <!-- 스탭 공통 처리 부분 -->
    <hr v-if="step < all">
    <b-button v-if="step > 1" block size="sm" variant="info" @click="prev()"> Prev </b-button>
    <b-button v-if="step < all"  block size="sm" variant="primary" @click="next()">Next </b-button>
    <b-button v-else  block size="sm" variant="success" @click="modal_save = true">Save </b-button>
    <hr>
    <b-row>
      <b-col>
        <center>{{step}} / {{all}}</center>
      </b-col>
    </b-row>
    <b-modal title="Policy Apply to agent(WAF)"  class="modal-success" v-model="modal_save" @ok="apply" ok-variant="success" header-bg-variant="warning">
      Should apply the settings?
      <hr>
      Detect mode allows you to check the detected logs without being blocked.
      <br>
      Settings can be changed at any time.
    </b-modal>
    <!-- 디버그 영역 -->
    <!-- {{policy}} -->
    <!-- {{policy_summary_list}} -->
    <!-- {{policy.rule}} -->
  </div>
</template>

<script>
import _ from 'lodash'
import RuleService from './Rule.Service'
import RuleIP from './Rule.IP.i18n'
import RuleCustom from './Rule.Custom.i18n'
import RuleMode from './Rule.Mode'

// 여기의 컨셉은 모든 설정을 한번에 다 하는 컨셉
export default {
  components: { RuleService, RuleIP, RuleCustom, RuleMode },
  name: 'RuleQuickSetup',
  props: ['quick_setting', 'ico', 'is_one', 'crs_rule', 'domain', 'rule_selected', 'setting_level', 'setting_mode', 'user', 'is_first'],
  watch: {
    setting_level() {
      this.policy.level = this.setting_level
    },
    setting_mode() {
      this.policy.mode = this.setting_mode
    },
    crs_rule() {
      // value update
      this.load()
    },
    quick_setting() {
      this.setting = this.quick_setting
      console.log('quick_setting updated')
    }
  },
  data: () => {
    return {
      // step 1 : 그냥 설명, 처음 설치시만 보여줄 거임
      // step 2
      is_more : false,
      // 공백 중요
      // rulekey (공격유형)
      policy_summary_list: [
        { text: 'IP-REPUTATION', value : [], use : true, indeterminate : false  },
        { text: 'METHOD-ENFORCEMENT', value : [], use : true, indeterminate : false  },
        { text: 'DOS-PROTECTION', value : [], use : true, indeterminate : false  },
        { text: 'SCANNER-DETECTION', value : [], use : true, indeterminate : false  },
        { text: 'PROTOCOL-ENFORCEMENT', value : [], use : true, indeterminate : false  },
        { text: 'COMMON-EXCEPTIONS', value : [], use : true, indeterminate : false  },
        { text: 'PROTOCOL-ATTACK', value : [], use : true, indeterminate : false  },
        { text: 'APPLICATION-ATTACK (LFI, RFI, RCE, PHP, XSS, SQLI, SESSION-FIXATION, WCON)', value : [], use : true, indeterminate : false },
        { text: 'DATA-LEAKAGES (SQL, JAVA, PHP, IIS)', value : [], use : true, indeterminate : false },
        { text: 'BLOCKING-EVALUATION', value : [], use : true, indeterminate : false  },
        { text: 'CORRELATION', value : [], use : true, indeterminate : false  },
      ],
      all_selected: true,
      all_indeterminate: false,
      // step 3
      allow_ip : "",
      // step 4
      path : "",
      // step 4
      modal_save : false,
      // common
      step : 1,
      all : 5,
      policy: {
        domain : '',
        rule : [],
        rule_by_name : [],
        custom_rule : '',
        parameter : '',
        block_ip : '',
        allow_ip : '',
        path : '',
        mode : 1,
        level : 1
      },
    }
  },
  computed: {
    summary_used_count() {
      return _.filter(this.policy_summary_list, r => r.use).length
    }
  },
  methods: {
    apply() {
      try {
        // 모든 데이터 수집
        let ruleMain = []
        _.forEach(this.policy.rule_by_name, r => ruleMain = _.concat(ruleMain, r))

        let rule = _.uniq(_.concat(ruleMain, this.policy.rule))
        let subs_rule = []

        this.$emit('quick_setting_update', this.setting)

        // sync
        let keys = Object.keys(this.setting)

        for (let l = 0; l < keys.length; l++) {
          let k = keys[l];
          // console.log(this.setting[k], this.setting[k].use, this.setting[k].key, this.setting[k].desc)
          // console.log(k, this.setting[k].use, this.setting[k].desc)
          // console.log(this.setting[k].use, 'key', this.setting[k].key)
          if(!this.setting[k].use) {

            (this.setting[k].key || []).forEach(key => {
              rule.push(key)
              // console.log('remove push', key)
            });

          } else {
            // 룰 삭제
            (this.setting[k].key || []).forEach(key => {
              _.remove(rule, key)
              // console.log('using', key, rule)
            });
          }
        }

        // 모든 키를 모았으니까 이제 놓아 주자
        _.forEach(this.crs_rule, r => {
          // console.log('collect', rule, r.key)
          if(_.indexOf(rule, r.key) < 0) { return }

          _.forEach(r.rules, rr => subs_rule.push(rr.key))
        })

        // 저장 시그널 전송
        // console.log('rule', rule, 'subs_rule', subs_rule)
        this.$emit('save_default', Object.assign({}, this.policy, { domain : this.domain, rule : _.compact(subs_rule), rule_by_name : [] }))
      } catch (e) { console.log(e); this.$toastr.e("load error #1") }
    },
    list() {
      this.$router.push({ name: 'webcastle_modules'});
    },
    next(step = undefined) {
      if(step) { this.step = step }
      else { this.step = this.step >= this.all ? this.all : this.step + 1 }
    },
    prev(step = undefined) {
      if(step) { this.step = step }
      else { this.step = this.step <= 0 ? 1 : this.step - 1 }
    },
    toggle_all(checked) {
      _.forEach(this.policy_summary_list, r => this.toggle_one(checked, r.value, true))
      this.all_selected = !this.all_selected
      // if(!this.all_selected) { this.all_indeterminate = this.all_selected }
    },
    // 기본 설정
    toggle_one(value, keys, force = false) {
      try {
        // 필터링 기본 룰 설정
        if(value) {
          this.policy.rule_by_name = _.filter(this.policy.rule_by_name, r => _.indexOf(keys, r) < -1 )
          // console.log("remove",  keys)
        } else {
          this.policy.rule_by_name = _.uniq(_.concat(keys, this.policy.rule_by_name))
          // console.log("update",  keys)
        }

        // 또 for 문 돌기 싫어서 사용함
        _.forEach(this.policy_summary_list, r => {

          if(_.filter(r.value, v => _.indexOf(keys, v) > -1).length < 1) { return }

          // 서비스중에 미사용 처리
          r.use = value
          Object.keys(this.setting).forEach(k => {

            if(_.filter(r.value, v => _.indexOf(this.setting[k].key, v) > -1).length < 1) { return console.log("no have it") }

            let duplicate = _.filter(keys, k1 => _.filter(this.setting[k].key,a => a == k1).length > 0)

            let test = _.filter(this.setting[k].key, k1 => _.filter(this.policy_summary_list, r1 => _.indexOf(r1.value, k1) > -1).length > 0)
            let used = _.filter(this.setting[k].key, k1 => _.filter(this.policy_summary_list, r1 => r1.use && _.indexOf(r1.value, k1) > -1).length > 0)

            // console.log(test, 'used', used, duplicate)
            if(duplicate.length > 0) {
              this.setting[k].use = value
              // 다른 룰 사용하는게 있는지 검사를 먼저 해야 함
              this.setting[k].indeterminate = used.length > 0 && test.length != used.length
            }
            if(value) {
              // rule 에 더하기
              r.indeterminate = false
            } else {
              // rule 에 더하기
              if(force && r.use) { r.indeterminate = false }
            }

          })
        })

        let has_use = _.filter(this.policy_summary_list, r1 => r1.use).length

        this.policy.rule_by_name = _.uniq(this.policy.rule_by_name)
        this.policy.rule_by_name = _.filter(this.policy.rule_by_name, r1 => r1 != '900')
        this.all_indeterminate = has_use == 0 ? false : true
        if(has_use == this.policy_summary_list.length) {
          this.all_indeterminate = false
          this.all_selected = true
        }

        // console.log(this.policy.rule_by_name.length, has_use, this.policy_summary_list.length)
        // if(has_use < 1) { this.all_selected = false }

        this.refresh()
        // console.log("this.all_indeterminate", this.all_indeterminate)
      } catch (e) { console.log(e); this.$toastr.e("load error #2") }
    },
    refresh() {
      // some action here
      this.$emit("refresh")
      this.$forceUpdate()
    },
    toggle_policy(value, key, type=undefined) {
      // 특정 룰을 사용하지
      try {
        if(value == false) {
          // not using
          this.policy.rule.push(key)
          console.log("remove push",  key, type, this.policy.rule)
        } else {
          // using
          this.policy.rule = _.filter((this.policy.rule || []), r => key != r)
          console.log("using",  key, type, this.policy.rule)
        }


        // 만약 겹치는 룰이 있을 경우 일부 사용처리
        this.policy_summary_list.forEach(r => {
          // 매치되는 타입 없을 경우, 확인 안함
          if(r.text.indexOf(type) < 0) { return }

          r.use = value
          r.indeterminate = _.filter(this.policy.rule, p => _.indexOf(r.value, (p.length > 6 ? p.substr(0, 4) : p.substr(0, 3))) > -1).length > 0
          // console.log(r.indeterminate, _.filter(this.policy.rule, p => _.indexOf(r.value, (p.length > 6 ? p.substr(0, 4) : p.substr(0, 3))) > -1))

        })
      } catch (e) { console.log(e); this.$toastr.e("load error #3") }
    },
    load() {
      try {
        // user cusom
        this.policy.custom_rule = this.user.custom_rule
        this.policy.block_ip = this.user.block_ip
        this.policy.allow_ip = this.user.allow_ip
        this.policy.path = this.user.path
        this.policy.parameter = this.user.parameter
        this.policy.domain = this.domain
        // waf setting
        this.setting = this.quick_setting
        this.step = this.is_one ? 2 : 1
        console.log(this.is_one ? 'continue just one' : 'agent installed more then one' )
        this.policy.rule = this.rule_selected && this.rule_selected.length ? this.rule_selected : []

        if(this.setting_level) { this.policy.level = this.setting_level }
        if(this.setting_mode) { this.policy.mode = this.setting_mode }

        // console.log("this.setting_level", this.setting_level)
        // console.log("this.setting_mode", this.setting_mode)
        this.crs_rule.forEach(r => {
          let count = 0
          let key = r.key.indexOf('.') > -1 ? r.key.split('.')[1] : r.key
          _.forEach(this.policy_summary_list, rr => {
            // console.log(r.desc, rr.text.split(' ')[0])
            let disable = _.filter(this.policy.rule, p => (p.length > 6 ? p.substr(0, 4) : p.substr(0, 3)) == key).length
            if(r.desc.indexOf(rr.text.split(' ')[0]) > -1) {

              rr.value.push(r.key)
              rr.use = disable > 0 ? false : true

              if(!rr.indeterminate && disable > 0 && _.filter(rr.value, r1 => r1 == key).length > 0) {
                rr.indeterminate = true
              }

              // for debug
              // if(r.desc.indexOf("APPLICATION-ATTACK") > -1) {
              //   console.log(rr.text, rr.indeterminate, _.filter(rr.value, r1 => r1 == key).length > 0, disable)
              // }
              // console.log(rr.text, rr.indeterminate, disable > 0 && disable < r.rules.length, r.rules.length, disable)
              if(!rr.use) { count += 1 }
            }
          })
          r.use = _.filter(_.map(r.rules, r1 => r1.key), r2 => _.indexOf(this.policy.rule, r2) > -1).length > 0 ? false : true
          // console.log(key, r.use)
          // 미사용 카운트
          if(count == 0) { this.all_selected = true; this.all_indeterminate = false }
          if(count > 0) { this.all_selected = false; this.all_indeterminate = true }
          if(count == this.policy_summary_list.length) { this.all_selected = false; this.all_indeterminate = false }
          // console.log('this.all_indeterminate', this.all_indeterminate, 'this.all_selected', this.all_selected, 'count', count)

          this.update_quick_setting(r)
        })

        Object.keys(this.quick_setting).forEach(k => {
          // console.log("test", _.filter(this.quick_setting[k].key, r => _.filter(this.policy.rule, p => p.length > 6 ? p.substr(0, 4) : p.substr(0, 3) == r).length > 0 ? true : false))
          // console.log(_.filter(this.quick_setting[k], r => _.filter(this.policy.rule, p => p.length > 6 ? p.substr(0, 4) : p.substr(0, 3) == r.key)))
          let cnt = _.filter(this.quick_setting[k].key, r => _.filter(this.policy.rule, p => (p.length > 6 ? p.substr(0, 4) : p.substr(0, 3)) == r.indexOf('.') > -1 ? r.split('.')[1] : r).length > 0 ? true : false).length
          if(cnt > 0) {
            // 만약 recommended 설정에도 있을 경우 조치가 필요
            let duplicate = _.filter(this.policy_summary_list, p => _.filter(this.quick_setting[k].key, d => _.indexOf(p.value, d) > -1).length > 0)
            let enable = _.filter(duplicate, w => w.use).length
            let disable = duplicate.length - enable

            this.quick_setting[k].indeterminate = false
            // this.quick_setting[k].use
            // console.log(this.quick_setting[k].key, this.quick_setting[k].use)
            if(duplicate.length > 1) { this.quick_setting[k].indeterminate = enable != disable }
          }
        })
      } catch (e) { console.log(e); this.$toastr.e("load error #4") }
    },
    // 같은
    update_quick_setting(r)
    {
      let data = {}
      switch (r.key) {
        case '903.9001': data = { DRUPAL : { use : r.use, key : this.parser_rule('DRUPAL'), indeterminate : r.indeterminate } }; break;
        case '903.9002': data = { WORDPRESS : { use : r.use, key : this.parser_rule('WORDPRESS'), indeterminate : r.indeterminate } }; break;
        case '952': data = { JAVA : { use : r.use, key : this.parser_rule('JAVA'), indeterminate : r.indeterminate } }; break;
        case '953': data = { PHP : { use : r.use, key : this.parser_rule('PHP'), indeterminate : r.indeterminate } }; break;
        case '954': data = { IIS : { use : r.use, key : this.parser_rule('IIS'), indeterminate : r.indeterminate } }; break;
        default: break;
      }
      if(data != {}) { this.setting = Object.assign({}, this.setting, data) }
    },
    parser_rule(keyword) { return _.map(_.filter(this.crs_rule, r => r.desc.indexOf(keyword) > -1), i => i.key) },
  },
  created: function() {   console.log('RuleQuickSetup.vue', 'created'); },
  destroyed: function() { console.log('RuleQuickSetup.vue', 'destroyed'); },
  mounted: function() {
    console.log('RuleQuickSetup.vue', 'mounted');
    try { this.load() } catch (e) { console.log('load failed', e) }
    // 스탭별 디버깅용
    // if(location.hostname == 'localhost') {
    //   this.is_more = true
    //   this.step = 2
    // }

  }
}
</script>
